module.exports = __webpack_public_path__ + "static/media/060-benin.66518a02.svg";